import styled from "styled-components"
import Flex from "@irati/ui/src/Flex"
import {Body} from "@irati/ui/src/Typography"
import {minWidthMedia} from "@irati/ui/src/global/media"
import padding from "@irati/ui/src/global/padding"

export const FiltersWrapper = styled(Flex)`
  ${minWidthMedia.desktop`
    flex-direction: row;
    justify-content: flex-end;
  `}
`

export const CategoriesWrapper = styled.div`
  margin-bottom: 25px;
`

export const CategoryTitle = styled(Body)`
  margin-top: ${padding.small};
`
